import { useMemo } from 'react';

import { Image } from '@codes/ui-kit/components/ui/image';

import { CheckGradientIcon } from '@codes/assets';

import { cloudPriceTable } from '../consts';

interface CloudDetailProps {
    currentCloud: any;
}

export const CloudDetail = ({ currentCloud }: CloudDetailProps) => {
    const getPlanType = (planType: '' | 'free' | 'basic' | 'pro' | 'adv' | 'ent' | undefined) => {
        switch (planType) {
            case 'free':
            case 'basic':
                return 'Free';
            case 'pro':
                return 'Pro';
            case 'adv':
            case 'ent':
                return 'Advanced';
            default:
                return 'Free';
        }
    };

    return useMemo(() => {
        if (!currentCloud) {
            return null;
        }

        const cloudPrice = cloudPriceTable.find(cloudPrice => cloudPrice.planType === currentCloud.planType);

        return (
            <div className="bg-background rounded-xl border-[0.6px] border-gradient mb-[30px]">
                <div className="py-4 px-5">
                    <div className="text-[24px] font-semibold text-gray-900">{getPlanType(currentCloud.planType)}</div>
                    <div className="text-[42px] font-semibold text-gray-900">{cloudPrice?.price}$</div>
                    <p className="text-gray-500">{cloudPrice?.billingText}</p>

                    <div className="space-y-[10px] mt-[14px]">
                        {currentCloud.features?.map((feature: string, index: number) => (
                            <div key={index} className="flex items-center gap-2">
                                <Image src={CheckGradientIcon} />
                                <span className="text-gray-900 text-sm font-medium">{feature}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }, [currentCloud]);
};
